import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Grid,
  Box,
  Typography,
  Chip,
  OutlinedInput,
  Stack,
  Tabs,
  Tab,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useTheme } from "@mui/system";
import useAuth from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};

export const AddDialog = ({ open, onClose, onSave }) => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);
  const [selectedUserToAdd, setSelectedUserToAdd] = useState("");
  const [usersAll, setUsersAll] = useState([]);
  const { getData } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const users = [
    {
      iduid: "2B3DA454-3F5A-4145-B773-B89B12B7E579",
      name: "Riccardo",
      role: "Ruolo 1",
    },
    {
      iduid: "7BEB1065-30D3-4CDE-8A1C-940B7433DD2B",
      name: "Vincenzo",
      role: "Ruolo 2",
    },
  ];

  /*  useEffect(() => {
    setIsLoading(true);
    getData({ action: "usersList" })
      .then((data) => {
        if (data.status === 0) {
          navigate("/private");
        }
        setUsersAll(data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []); */

  const [formData, setFormData] = useState({
    titolo: "",
    descrizione: "",
    tipo: "info",
    targetUserId: "", // NEW: For targeted Socket.IO messaging
    targetUsers: [],
    allowComments: false,
    allowLikes: false,
    showPopup: false,
    expirationDate: "",
  });

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "allowComments" ||
        name === "allowLikes" ||
        name === "showPopup"
          ? checked
          : value,
    }));
  };

  const handleAddUser = () => {
    if (
      selectedUserToAdd &&
      !formData.targetUsers.includes(selectedUserToAdd)
    ) {
      setFormData((prev) => ({
        ...prev,
        targetUsers: [...prev.targetUsers, selectedUserToAdd],
      }));
      setSelectedUserToAdd("");
    }
  };

  const handleRemoveUser = (userId) => {
    setFormData((prev) => ({
      ...prev,
      targetUsers: prev.targetUsers.filter((id) => id !== userId),
    }));
  };

  const handleSubmit = () => {
    /*  if (
      !formData.titolo ||
      !formData.descrizione ||
      formData.targetUsers.length === 0
    ) {
      
      if (formData.targetUsers.length === 0) {
        alert("Seleziona almeno un destinatario nella tab Utenti.");
        return;
      }
      return;
    } */
    onSave(formData);
    /* handleClose(); */
  };

  const handleClose = () => {
    onClose();
    // Reset form
    setFormData({
      titolo: "",
      descrizione: "",
      tipo: "info",
      targetUsers: [],
      allowComments: false,
      allowLikes: false,
      showPopup: false,
      expirationDate: "",
    });
    setActiveTab(0);
    setSelectedUserToAdd("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle>Manda Nuovo Avviso</DialogTitle>
      <DialogContent sx={{ height: 400 }}>
        <Box width="100%">
          <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)}>
            <Tab label="Generale" />
            <Tab label="Utenti" />
          </Tabs>

          <CustomTabPanel value={activeTab} index={0}>
            <Grid container spacing={3} mt={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Tipo</InputLabel>
                  <Select
                    name="tipo"
                    value={formData.tipo}
                    label="Tipo"
                    onChange={handleChange}
                  >
                    <MenuItem value="info">Info</MenuItem>
                    <MenuItem value="urgent">Urgente</MenuItem>
                    <MenuItem value="task">Task</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Titolo"
                  name="titolo"
                  value={formData.titolo}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Descrizione"
                  name="descrizione"
                  value={formData.descrizione}
                  onChange={handleChange}
                  multiline
                  rows={4}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  Opzioni Aggiuntive
                </Typography>
                <Stack direction="row" spacing={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.allowComments}
                        onChange={handleChange}
                        name="allowComments"
                        sx={{
                          "&.MuiSwitch-root .MuiSwitch-switchBase": {
                            color: "#ccc",
                          },
                          "&.MuiSwitch-root .Mui-checked": {
                            color: "#407ad6",
                          },
                        }}
                      />
                    }
                    label="Commenti"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.allowLikes}
                        onChange={handleChange}
                        name="allowLikes"
                        sx={{
                          "&.MuiSwitch-root .MuiSwitch-switchBase": {
                            color: "#ccc",
                          },
                          "&.MuiSwitch-root .Mui-checked": {
                            color: "#407ad6",
                          },
                        }}
                      />
                    }
                    label="Like"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.showPopup}
                        onChange={handleChange}
                        name="showPopup"
                        sx={{
                          "&.MuiSwitch-root .MuiSwitch-switchBase": {
                            color: "#ccc",
                          },
                          "&.MuiSwitch-root .Mui-checked": {
                            color: "#407ad6",
                          },
                        }}
                      />
                    }
                    label="Mostra Popup"
                  />
                </Stack>
                <FormControl fullWidth required sx={{ mt: 2 }}>
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    renderInput={(props) => <TextField {...props} />}
                    label="Data Scadenza"
                    name="Data_Scadenza"
                    id="Data_Scadenza"
                    value={
                      formData.expirationDate === ""
                        ? null
                        : dayjs(formData.expirationDate, "DD/MM/YYYY")
                            .utc()
                            .toISOString()
                    }
                    onChange={(e) => {
                      const value = dayjs(e).format("DD/MM/YYYY");
                      setFormData((prev) => ({
                        ...prev,
                        expirationDate: value,
                      }));
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </CustomTabPanel>

          <CustomTabPanel value={activeTab} index={1}>
            {isLoading ? (
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
              </Box>
            ) : (
              <>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  marginBottom={2}
                >
                  <FormControl size="small" fullWidth>
                    <InputLabel>Seleziona Utente</InputLabel>
                    <Select
                      value={selectedUserToAdd}
                      label="Seleziona Utente"
                      onChange={(e) => setSelectedUserToAdd(e.target.value)}
                    >
                      {users?.map((u) => (
                        <MenuItem key={u.iduid} value={u.iduid}>
                          {u.name} ({u.role}) -- {u.iduid}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Button
                    variant="contained"
                    onClick={handleAddUser}
                    disabled={!selectedUserToAdd}
                  >
                    Aggiungi
                  </Button>
                </Box>

                <Paper
                  variant="outlined"
                  sx={{ width: "100%", overflow: "hidden" }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Ruolo</TableCell>
                        <TableCell>Utente</TableCell>
                        <TableCell align="right">Azioni</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData.targetUsers.length > 0 ? (
                        formData.targetUsers.map((userId) => {
                          const user = users.find((u) => u.iduid === userId);
                          if (!user) return null;
                          return (
                            <TableRow key={userId}>
                              <TableCell>{user.role || "-"}</TableCell>
                              <TableCell>{user.name}</TableCell>
                              <TableCell align="right">
                                <IconButton
                                  size="small"
                                  onClick={() => handleRemoveUser(userId)}
                                  color="error"
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={3} align="center">
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Nessun destinatario selezionato
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              </>
            )}
          </CustomTabPanel>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Annulla
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Invia
        </Button>
      </DialogActions>
    </Dialog>
  );
};
